
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  A textarea (text area) is an input field used on a form to request information
  from a user. Use a text area when the expectation is that a user will enter a
  large amount of information with their keyboard.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/TextArea/Text%20Area2.jpg" alt="Anatomy of text area" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <h3>{`Default`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Title of the text area`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Additional information the user might need, to help them provide the correct data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Text area`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The area where the user enters their response`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Conditional (invalid or missing input)`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional indicator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicator stating `}<strong parentName="td">{`if`}</strong>{` input fields are `}<strong parentName="td">{`optional`}</strong>{`. `}<strong parentName="td">{`All fields are mandatory by default - only ask for information that is required`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Error message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A message informing the user `}<strong parentName="td">{`if`}</strong>{` there is a problem with their entry`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`minimise`}</strong>{` the number of input fields - only ask for necessary information`}</li>
      <li parentName="ul"><strong parentName="li">{`arrange them vertically`}</strong>{` to improve scannability and reduce errors`}</li>
      <li parentName="ul"><strong parentName="li">{`group`}</strong>{` related fields together`}</li>
      <li parentName="ul"><strong parentName="li">{`order`}</strong>{` input fields logically, matching real-world task succession and interactions`}</li>
      <li parentName="ul">{`always `}<strong parentName="li">{`label each text area`}</strong>{` with a short, distinct and indicative title, `}<strong parentName="li">{`placed above the text area`}</strong></li>
      <li parentName="ul">{`indicate whether the input field is `}<strong parentName="li">{`optional`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`make use of helper text`}</strong>{` if there are further directions or hints the users may need in completing their goal (`}<strong parentName="li">{`example`}</strong>{`: `}<em parentName="li">{`Must be at least 6 characters and contain a number and a special character`}</em>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`allow copy/paste`}</strong>{` for ease of use`}</li>
      <li parentName="ul">{`if a character counter is necessary, place it below the text area`}</li>
      <li parentName="ul">{`match the text field area to the expected size of the input - make it wide enough for the user to see their entire entry`}</li>
      <li parentName="ul"><strong parentName="li">{`write specific and indicative error texts so users understand how to fix the error`}</strong></li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't use placeholder text`}</strong>{` in the text area - this may not be read by screen reading software, leading to accessibility issues`}</li>
      <li parentName="ul"><strong parentName="li">{`don't have a mandatory minimum`}</strong>{` input of characters`}</li>
      <li parentName="ul"><strong parentName="li">{`don't restrict`}</strong>{` the use of uncommon or `}<strong parentName="li">{`special characters`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`don't disable copy and paste`}</strong>{` functions`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`use in any situation where the user needs `}<strong parentName="li">{`to input a large, or unknown`}</strong>{`, amount of data`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`do not use`}</strong>{` when expected input is `}<strong parentName="li">{`short or limited`}</strong>{` - use a `}<Link to="/eu/components/forms/text-field/usage/" mdxType="Link">{`Text field`}</Link>{` instead`}</li>
      <li parentName="ul"><strong parentName="li">{`do not use`}</strong>{` when the user must respond `}<strong parentName="li">{`with specific options which are known to the organisation`}</strong>{` - use form types such as Checkboxes, `}<Link to="/eu/components/forms/radio/usage/" mdxType="Link">{`Radio Buttons`}</Link>{` or `}<Link to="/eu/components/forms/select/usage/" mdxType="Link">{`Selects`}</Link>{` instead`}</li>
    </ul>
    <h2>{`Notes`}</h2>
    <h3>{`Accessibility`}</h3>
    <ul>
      <li parentName="ul">{`placeholder text in a text field is bad for accessibility - may not be read by screen reading software, and can be problematic for users with a visual impairment; use helper text is further information needs to be conveyed`}</li>
    </ul>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><Link to="/eu/components/forms/radio/usage/" mdxType="Link">Radio button</Link></li>
      <li parentName="ul"><Link to="/eu/components/forms/select/usage/" mdxType="Link">Select</Link></li>
      <li parentName="ul"><Link to="/eu/components/forms/text-field/usage/" mdxType="Link">Text field</Link></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;